import Vue from 'vue'
import { InputNumber, Link, Badge, Image, Loading, Notification, DropdownItem, DropdownMenu, Dropdown, TabPane, Tabs, Progress, Upload, Tag, CheckboxGroup, Checkbox, Select, Option, DatePicker, Dialog, Button, Form, FormItem, Input, Message, MessageBox, Container, Header, Aside, Main, Menu, Submenu, MenuItem, MenuItemGroup, Breadcrumb, BreadcrumbItem, Card, Row, Col, Table, TableColumn, Switch, Pagination } from 'element-ui'

Vue.use(InputNumber)
Vue.use(Link)
Vue.use(Badge)
Vue.use(Image)
Vue.use(Loading)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Dropdown)
Vue.use(TabPane)
Vue.use(Tabs)
Vue.use(Progress)
Vue.use(Upload)
Vue.use(Tag)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(Dialog)
Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Switch)
Vue.use(Pagination)

Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
